module.exports = __webpack_public_path__ + "static/media/mars.4e737ab6.jpg";